<ion-grid class="ion-no-padding" style="height: 100%">
  <ion-row class="ion-no-padding ion-no-margin ion-justify-content-center ion-align-items-center"
    style="height: 100%; flex-direction: column">
    <div class="no-shadow ion-text-center">
      <custom-icon
        [iconName]="image"
        [width]="250"
        [height]="250"
        colorClass="modalIcon"
        class="ion-padding" 
        style="max-width: 350px; width:100%; margin: auto;"
      ></custom-icon>
      <ion-text class="error-black-text-color">
        <h2>{{"page_status.no_network.whoops" | translate}}</h2>
        <p>{{"page_status.no_network.no_internet_connection_found" | translate}}</p>
        <p>{{"page_status.no_network.check_your_connection" | translate}}</p>
      </ion-text>
      <ion-button (click)="reloadPage()" class="ion-margin primary-btn" expand="block">
        <ion-ripple-effect></ion-ripple-effect>
        {{"page_status.no_network.try_again" | translate}}
      </ion-button>
    </div>
  </ion-row>
</ion-grid>
